import { z } from "zod";
export const upsertPMFeedbackDtoSchema = z.object({
    feedbackId: z.string().optional(),
    alarmId: z.string(),
    feedbackVersion: z.string().nullable(),
    answer1: z.string().nullable(),
    answer2: z.string().nullable(),
    answer3: z.string().nullable(),
    answer4: z.string().nullable(),
});
export const pmFeedbackDtoSchema = z.object({
    feedbackId: z.string(),
    alarmId: z.string(),
    createdAt: z.string(),
    userId: z.string(),
    userName: z.string(),
    answer1: z.string().nullable(),
    answer2: z.string().nullable(),
    answer3: z.string().nullable(),
    answer4: z.string().nullable(),
});
//# sourceMappingURL=predictive-maintenance-feedback.schema.js.map